import React from 'react';
import { useModal } from '../../hooks/modalContext';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Icon } from '../../Icons/Icon';
import { usePoints } from '../../hooks/pointsContext';
import HtmlOrText from '../../utils/HtmlOrText';

const GiftCardDetails: React.FC = () => {
  const { setModal, modalState } = useModal();
  const { points } = usePoints();
  const selectedCard = modalState?.selectedCard;

  const renderGiftCardDetails = () => {
    if (!selectedCard) return null;

    const redeemGiftCard = () => {
      setModal('redeem-gift-card', {
        giftPrices: selectedCard.allowed_prices_in_cents,
        brandCode: selectedCard.brand_code,
        fromModal: 'all-gift-cards',
      });
    };

    return (
      <div className='flex flex-col gap-8'>
        <div className='flex flex-col items-center text-center px-2'>
          <div
            className='w-[150px] h-[150px] bg-center bg-cover bg-no-repeat rounded-xl mb-4'
            style={{ backgroundImage: `url(${selectedCard.image_url})` }}
          />
          {selectedCard.description && (
            <div className='w-full items-start flex flex-col gap-1'>
              <span className='text-main text-base font-bold'>Description</span>
              <HtmlOrText
                className='text-base text-main text-start'
                content={selectedCard.description}
              />
            </div>
          )}

          {selectedCard.disclaimer && (
            <HtmlOrText
              className='text-xs text-red-500 mt-2 text-start'
              content={selectedCard.disclaimer}
            />
          )}
          <button className='submitBtn mt-5' onClick={() => redeemGiftCard()}>
            <div className='flex justify-between p-6 w-full'>
              <span>Redeem TP points</span>
              <ArrowRight />
            </div>
          </button>
        </div>
      </div>
    );
  };

  return (
    <motion.div
      className='relative w-[992px] max-h-[852px] bg-[#FFF] rounded-[12px] flex flex-col overflow-auto px-5 py-10'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {/* Header */}
      <div className='flex justify-between items-center w-full mb-5'>
        <div className='flex justify-center items-center gap-2'>
          <ArrowLeft className='h-5 w-5 cursor-pointer' onClick={() => setModal(null)} />
          <span className='text-main text-[20px]'>{selectedCard?.name}</span>
        </div>

        <div
          className='flex items-center gap-2 bg-[var(--Primary-Color,#0055FF)] rounded-full px-3 py-2 h-9 cursor-pointer'
          onClick={() => setModal('rewards')}
        >
          <Icon name='wallet' color='rgba(236,188,33,1)' className='w-6 h-6' />
          <span className='text-white text-lg'>
            {Number(points?.data?.points?.totalAvailable ?? 0).toLocaleString('en-US')}
          </span>
        </div>
      </div>
      {renderGiftCardDetails()}
    </motion.div>
  );
};

export default GiftCardDetails;
